import TelegramIcon from '@mui/icons-material/Telegram';
import KeyboardDoubleArrowRightIcon from '@mui/icons-material/KeyboardDoubleArrowRight';
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
import PhoneIcon from '@mui/icons-material/Phone';
import ViewList from '@mui/icons-material/ViewList';

import * as React from 'react';

const contactsData = [
  {
    Icon: TelegramIcon,
    title: 'Телеграм канал',
    color: 'text-[#359BFF]',
    description: 'Следите за новостями и задавайте вопросы',
    isBlank: true,
    href: 'https://t.me/zabota_mr_bot',
  },
  {
    Icon: ViewList,
    title: 'Каталог',
    color: 'text-orange-500',
    description: 'Переходите в наш каталог и заказывайте умные устройства',
    isBlank: true,
    href: 'https://meridian.pro',
  },
  {
    Icon: EmailOutlinedIcon,
    title: 'info@meridian.pro',
    color: 'text-orange-500',
    description: 'Пишите нам письма с вопросами и предложениями',
    href: 'mailto:info@meridian.pro',
  },
  {
    Icon: PhoneIcon,
    title: '+7 (495) 725-27-55',
    color: 'text-orange-500',
    description: 'Вы также можете позвонить нам, *короткий номер бесплатный по всей территории РФ',
    href: 'tel:+74957252755',
  },
];

const Contacts = () => {
  return (
    <div className="w-full max-w-sm sm:max-w-sm md:max-w-xl lg:max-w-2xl xl:max-w-4xl 2xl:max-w-5xl">
      <div className="bg-white shadow-2xl rounded-b-3xl border-b border-x border-gray-300 px-6 pt-6 pb-8">
        {contactsData.map((contact) => {
          const { Icon, color, title, description, href, isBlank } = contact;

          return (
            <div key={title} className="grid grid-cols-12 gap-4 items-center justify-items-center border-b p-2 ">
              <a href={href} className="col-span-1 cursor-pointer block">
                <Icon className={`w-6 sm:w-6 xl:w-8 2xl:w-8 h-6 sm:h-6 xl:h-8 2xl:h-8 ${color}`} />
              </a>
              <div className="col-span-10 justify-self-start">
                <p className="text-wrap">{title}</p>
                <p className="text-xs text-wrap select-none">{description}</p>
              </div>

              {isBlank && (
                <div className="col-span-1">
                  <a target="_blank" href={href} rel="noreferrer">
                    <KeyboardDoubleArrowRightIcon className="w-6 sm:w-6 xl:w-8 2xl:w-8 h-6 sm:h-6 xl:h-8 2xl:h-8 fill-gray-900 hover:fill-orange-500 animate-pulse"></KeyboardDoubleArrowRightIcon>
                  </a>
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default Contacts;
